import { render, staticRenderFns } from "./AdministrationFilled.vue?vue&type=template&id=297cfcf2"
import script from "./AdministrationFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministrationFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports